// extracted by mini-css-extract-plugin
module.exports = {"description":"EvHZ7Qw5QWHz2B6jcMFBXQ=="};